export default "__VITE_ASSET__0005207c__"